import type { Directive, DirectiveBinding } from 'vue'

interface AutoSizeOptions {}

type El = HTMLInputElement | HTMLTextAreaElement;

class AutoSizeWrap
{
	protected el : El;
	protected mirror : HTMLElement;
	protected handler : Function;

	public constructor(el : El) {
		this.el = el;
		this.mirror = this.createFakeElement(el);
		this.handler = () => this.resize();
	}

	protected createFakeElement(el : El) : HTMLElement
	{

		let mirror = document.createElement('span')
		let style = getComputedStyle(el)

		mirror.style.position = 'fixed'
		mirror.style.visibility = 'hidden'
		mirror.style.left = '500%';
		mirror.style.top = '500%';
		mirror.style.whiteSpace = 'pre'
		mirror.style.font = style.font
		mirror.style.padding = style.padding
		mirror.style.border = style.border

		return mirror;

	}

	public resize() : void
	{

		this.mirror.textContent = this.el.value || ' ';

		this.el.style.width = (this.mirror.scrollWidth) + 'px';

	}

	public init() : void
	{
		document.body.appendChild(this.mirror);
	}

	public destroy() : void
	{
		this.mirror.remove();
	}

}

let elements = new WeakMap<El>();

let autoSize : Directive<El, AutoSizeOptions | undefined> = {
	mounted(el: El, binding: DirectiveBinding<AutoSizeOptions | undefined>) {

		let wrap = new AutoSizeWrap(el);

		wrap.init();
		wrap.resize();

		elements.set(el, wrap);

	},
	updated(el : El){

		let wrap = elements.get(el);

		wrap.resize();

	},

	unmounted(el: El) {

		let wrap = elements.get(el);

		wrap.destroy();

		elements.delete(el);

	}
}

export default autoSize;